import { infrastructuresRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { InfrastructureCostModel } from '../domain';
import { InfrastructureCostJson } from '../types';

export const useUpdateInfrastructureCost = () =>
  useMutation<InfrastructureCostModel, unknown, InfrastructureCostJson>(
    (infrastructureCost) =>
      infrastructuresRepo.updateInfrastructureCost(infrastructureCost),
  );
